/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodWareDishIcon20Regular = forwardRef('FoodWareDishIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10.75 5.582a1.75 1.75 0 1 0-1.5 0v1.454A7.811 7.811 0 0 0 4.52 9.27a7.82 7.82 0 0 0-2.27 5.48.75.75 0 0 0 1.5 0c0-1.642.67-3.259 1.83-4.42A6.307 6.307 0 0 1 10 8.5c1.642 0 3.259.67 4.42 1.83a6.307 6.307 0 0 1 1.83 4.42.75.75 0 0 0 1.5 0 7.82 7.82 0 0 0-2.27-5.48 7.811 7.811 0 0 0-4.73-2.234V5.582Z" }),
        React.createElement("path", { d: "M1 16.5A.75.75 0 0 0 1 18h18a.75.75 0 0 0 0-1.5H1Z" })));
});
